import Vue from 'vue'

// 建议放在element-ui后面，可以覆盖element-ui样式
import '@/assets/styles/index.scss'
import '@/assets/icons'

import EuLoading from '@/components/EuLoading'
import MCornerDecoration from '@/components/MCornerDecoration'
import EuEditor from '@/components/EuEditor'
import EuDrawer from '@/components/EuDrawer'
import MBlockHeader from '@/components/MBlockHeader/index.vue'
import UploadFile from '@/components/UploadFile/index.vue'
import Pagination from '@/components/Pagination'
import TableColumnSettingDialog from '@/components/TableColumnSettingDialog/index.vue'
import QueryExpandWrapper from '@/components/Crud/QueryExpandWrapper/index.vue'
import EuTableToolbar from '@/components/Crud/EuTableToolbar/index.vue'
import ContentBlock from '@/components/ContentLayout/ContentBlock.vue'
import ContentFooter from '@/components/ContentLayout/ContentFooter.vue'
import ContentLayout from '@/components/ContentLayout/ContentLayout.vue'
import ContentBlockHeader from '@/components/ContentLayout/ContentBlockHeader.vue'
import AttachmentContentBlock from '@/components/AttachmentContentBlock'
import AttachmentImageBlock from '@/components/AttachmentContentBlock/image.vue'
import GeOperLogDrawer from '@/components/GeOperLogDrawer'
import FilePreview from '@/components/FilePreview'
import TableSelectionTotalCollapse from '@/components/TableSelectionTotalCollapse'
import TableSelectionTotalCollapseItem from '@/components/TableSelectionTotalCollapse/TableSelectionTotalCollapseItem'
import TotalBlock from '@/components/TotalBlock'
import TotalBlockRow from '@/components/TotalBlock/TotalBlockRow'
import TotalBlockItem from '@/components/TotalBlock/TotalBlockItem'
import Money from '@/components/Money'
import CollapseButton from '@/components/CollapseButton/index.vue'
import BlockList from '@/components/BlockList/index.vue';
import BlockListRow from '@/components/BlockList/BlockListRow.vue';
import BlockListRowItem from '@/components/BlockList/BlockListRowItem.vue';
import NumberRangeInput from '@/components/NumberRangeInput/index.vue';

const components = [
  EuLoading,
  MCornerDecoration,
  EuEditor,
  EuDrawer,
  MBlockHeader,
  UploadFile,
  Pagination,
  TableColumnSettingDialog,
  QueryExpandWrapper,
  EuTableToolbar,
  ContentBlock,
  ContentFooter,
  ContentLayout,
  ContentBlockHeader,
  AttachmentContentBlock,
  AttachmentImageBlock,
  GeOperLogDrawer,
  FilePreview,
  TableSelectionTotalCollapse,
  TableSelectionTotalCollapseItem,
  TotalBlock,
  TotalBlockRow,
  TotalBlockItem,
  Money,
  CollapseButton,
  BlockList,
  BlockListRow,
  BlockListRowItem,
  NumberRangeInput,
]

components.forEach(component => {
  Vue.component(component.name, component)
})

// 导入自定义的表单组件
import mFormItemComponents from '@/utils/m-form-item-components'
Object.keys(mFormItemComponents).forEach(key => {
  Vue.component(key, mFormItemComponents[key])
})

// 指令
import directive from '@/directive'
Vue.use(directive)

import { download } from '@/utils/request'
import DataTimeRangePickerOptions from '@/utils/elementUI_DataTimeRange_PickerOptions'
import {
  enumsParse,
  enumsParseLabel,
  enumsConvertToList
} from '@/utils/enums'
import businessEnums from '@/utils/business-enums'
import { defaultSetting } from '@/settings'
import { hasPermission, hasRole } from '@/utils/permission'
import { openNewWindow, openTableColumnSettingDialog, printHtml } from '@/utils/eu'
import { EU_TABLE_COLUMN_FIELD_OPERATION } from '@/utils/constants'
import { limitInputNumber } from '@/utils'

Vue.prototype.$download = download
Vue.prototype.download = download
Vue.prototype.$DataTimeRangePickerOptions = DataTimeRangePickerOptions
Vue.prototype.$enumsParse = enumsParse
Vue.prototype.$enumsParseLabel = enumsParseLabel
Vue.prototype.$enumsConvertToList = enumsConvertToList
Vue.prototype.$enums = businessEnums
Vue.prototype.defaultSetting = defaultSetting
Vue.prototype.$permission = hasPermission
Vue.prototype.$role = hasRole
Vue.prototype.$openTableColumnSettingDialog = openTableColumnSettingDialog
Vue.prototype.$tableColumnField = {
  operation: EU_TABLE_COLUMN_FIELD_OPERATION
}
Vue.prototype.$openNewWindow = openNewWindow
Vue.prototype.$printHtml = printHtml
Vue.prototype.$limitInputNumber = limitInputNumber

// 过滤器
// 货币格式化过滤器：保留两位小数，并添加千分位分隔符
Vue.filter('moneyFormat', function (value) {
  if (value === null || value === undefined || value === '') {
    return '-'
  }

  const yuan = Number(value)

  // 四舍五入保留两位小数
  const rounded = Math.round(yuan * 100) / 100

  // 添加千分位分隔符
  return rounded.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})


// 过滤器
Vue.filter('tonFormat', function (value) {
  if (value === null || value === undefined || value === '') {
    return '-'
  }

  const yuan = Number(value)

  // 四舍五入保留两位小数
  const rounded = Math.round(yuan * 1000) / 1000

  // 添加千分位分隔符
  return rounded.toLocaleString('zh-CN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  })
})

